module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kAz5G"))).then(() => module.bundle.root('37nVf'));